<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">设备名称：</span>
        <el-input v-model="deviceName" clearable placeholder="请输入设备名称"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">采集时间：</span>
        <el-date-picker
          v-model="timeData"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <div class="header_item">
        <el-button v-if="showButton('search')" icon="el-icon-search" @click="searchSanatoriumList(true)">查询</el-button>
        <el-button v-if="showButton('export')" icon="el-icon-download" >导出Excel</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="sanatoriumList"
        height="100%">
        <el-table-column label="序号" width="60" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deviceName" label="设备名称" align="center"></el-table-column>
        <el-table-column prop="temp" label="温度" align="center"></el-table-column>
        <el-table-column prop="pipeNum" label="湿度" align="center"></el-table-column>
        <el-table-column prop="createTime" label="采集时间" align="center"></el-table-column>、
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia';
  export default {
    data() {
      return {
        deviceName: '',
        timeData: '',
        loading: false,
        total: 0,
        pageNum: 1,
        pageSize: 10,
        sanatoriumList: [],
      }
    },
    mounted() {

    },
    methods: {
      // 查询静养区监测信息
      searchSanatoriumList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.loading = true;
        this.sanatoriumList = [];
        this.$api.DuctpiecePLM.searchSanatoriumList({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }).then((res) => {
          if(res.success) {
            this.total = res.data.total;
            this.sanatoriumList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchSanatoriumList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchSanatoriumList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },
    },
  }
</script>

<style lang="scss" scoped>
@import "../../style/layout-main.scss";
</style>